export function buildMegaventorySalesOrderUrl(mvId: string | null): string | null {
  if (!mvId) return null;
  const configuredBase = import.meta.env.VITE_MEGAVENTORY_ORDER_BASE_URL?.trim();
  const defaultBase = "https://smartgridsolutions.megaventory.com/inventory/?document=SalesOrder&id=";
  const base = configuredBase && configuredBase.length > 0 ? configuredBase : defaultBase;
  return `${base}${encodeURIComponent(mvId)}`;
}
